import { Injectable } from "@angular/core";
import { from, interval } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { Library, Loader } from '@googlemaps/js-api-loader';
import { environment } from '@environment/environment';
import { Observable } from "rxjs-compat";

@Injectable()
export class GoogleService {

    private googleMapLoader: Loader;
    constructor() {
        this.googleMapLoader = new Loader({
            apiKey: environment.mapApiKey,
            version: "weekly",
            libraries: ["places"]
        });

    }

    load(lib: Library) {
        return from(this.googleMapLoader
            .importLibrary(lib)
            .then((google) => {
                return true;
            })
            .catch(e => {
                console.log("Error load Google Map " + e.toString());
                return false;
            }));

    }

    isGoogleMapLoaded() {
        return interval(500).pipe( // Check every 500ms
            map(() => typeof google !== 'undefined' && !!google.maps),
            filter((isReady) => isReady), // Only pass true values
            first() // Complete after first true value
        );

    }

}